import { MonetizationType, OfferType, PresentationType } from '@/@types/graphql-types';
import { HorizontalTitleListItem } from '@/components/timeline/types';
import { useRentalModal } from '@/features/jwtv-titles-rental/composables/useRentalModal';
import { ClickoutUrl, trackClickout } from '@/helpers/clickout-helper';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { ClickoutPlacement } from '@/interfaces/snowplow/clickout-context';

export const useXmasJwtvTvodSRExperiment = () => {
	const { openRentalModal } = useRentalModal();
	async function onPosterXmasSRClick(title: HorizontalTitleListItem, placement?: ClickoutPlacement) {
		const JWTV_RENTAL_OFFER = {
			presentationType: PresentationType.Hd,
			monetizationType: MonetizationType.Rent,
			newElementCount: 0,

			userLocalCurrency: null,
			retailPriceConverted: null,
			currency: 'AUD',
			lastChangeRetailPriceValue: null,
			type: OfferType.Standard,
			country: 'AU',
			package: {
				id: 'cGF8MjI4NQ==',
				packageId: 2285,
				clearName: 'JustWatchTV',
				shortName: 'jwt',
				technicalName: 'justwatchtv',
				icon: '/icon/321804885/s100/justwatchtv.{format}',
				iconWide: '/icon_wide/321804964/s160/justwatchtv.{format}',
				planOffers: [],
				__typename: 'Package',
			},
			plans: [],
			standardWebURL: `https://www.justwatch.com${title.content.fullPath}?package=jwt`,
			preAffiliatedStandardWebURL: null,
			streamUrl: '',
			streamUrlExternalPlayer: null,
			elementCount: 0,
			availableTo: null,
			subtitleLanguages: [],
			videoTechnology: [],
			audioTechnology: [],
			audioLanguages: [],
			__typename: 'Offer',
		};

		const titleContext = new SnowplowTitleContextGraphql(title.objectId, title.objectType);
		const clickoutUrl = new ClickoutUrl(JWTV_RENTAL_OFFER)
			.setTitleSourceId(title?.id ?? null)
			.addContexts(titleContext)
			.updateContext('ClickoutContextGraphql', 'clickoutType', 'sr_title_list')
			.updateContext('ClickoutContextGraphql', 'placement', placement)
			.updateContext('TitleContextGraphql', 'jwRawEntityId', title?.id);

		trackClickout(clickoutUrl);

		await openRentalModal({
			//@ts-ignore
			title: title,
			//@ts-ignore
			offer: JWTV_RENTAL_OFFER,
			clickoutUrl: clickoutUrl,
			expPromoCode: {
				code: 'XMAS20',
				queryParam: 'XMAS20',
			},
			additionalContexts: [],
			overrideRedirectUrl: true,
		});
	}
	return {
		onPosterXmasSRClick,
	};
};
